export default {
    extrato: { method: 'GET', url: 'extrato{/idEmpresa}{/dataInicio}{/dataFim}' },
    conciliacao: { method: 'GET', url: 'conciliacao{/idEmpresa}{/dataInicio}{/dataFim}' }
};